import { SvgRightCarat } from "../SVG/svg";

const AppTileLink = (props) => {
    return (
        <div className="card-footer relative">
            {props.showArrow &&
                <SvgRightCarat />
            }
        </div>
    )
}

export default AppTileLink;
